import { useModuleBEM } from "@b2bportal/core-themes";
import type { IFintechLineItem } from "@b2bportal/core-types";
import styles from "./styles.module.scss";

export const FintechLineItem = ({ title, price }: IFintechLineItem) => {
  const [block, cn] = useModuleBEM(styles, "FintechContainer");

  return (
    <div className={block}>
      <div className={cn("line-item")}>
        <div className={cn("summary-item-label")}>{title}</div>
        <div className={cn("summary-item-value")}>{price}</div>
      </div>
    </div>
  );
};
